import React from 'react';
import MemoryEditContextProvider from 'components/Providers/ContextProviders/MemoryEditContextProvider';
import { Grid } from '@mui/material';
import MemoryEditHeader from './MemoryEditHeader';
import MemoryQAContainer from './MemoryQAContainer';

function MemoryQA() {
  return (
    <MemoryEditContextProvider>
      <Grid container>
        <MemoryEditHeader />
        <MemoryQAContainer />
      </Grid>
    </MemoryEditContextProvider>
  );
}

export default MemoryQA;
